// extracted by mini-css-extract-plugin
module.exports = {"tier":"Tier_tier__2eqTA","tierTop":"Tier_tierTop__1paOF","tierLabel":"Tier_tierLabel__2MBnR","bigCircle":"Tier_bigCircle__2vO5p","smallCircle":"Tier_smallCircle__RJuiP"};